import {ShellBase} from '@/entryPoints/lib/shell-base';
import B2cMiniCart from '@/components/mini-cart/b2c/B2cMiniCart.vue';
//Vue Components
import {handleKioskLinks} from '@/composables/kiosk-links';
class Shell extends ShellBase {
  constructor(pageComponents = {}, vueRouter = null) {
    super({...pageComponents, B2cMiniCart}, vueRouter);
  }

  loadPlugins() {
    // Load common plugins from Shell
    super.loadPlugins();
    window.addEventListener('load', () => handleKioskLinks());
  }
}

export {Shell};
